import { Typography, useTheme } from '@mui/material';
import HtmlRenderer from 'react-html-renderer';

export default function HTMLRenderer({ value, ...other }) {
	const theme = useTheme();

	return (
		<Typography {...other} component="div">
			<HtmlRenderer
				html={value}
				components={{
					p: componentProps => <p {...componentProps} style={{ margin: 'initial' }} />,
					a: ({ children, ...otherProps }) => (
						<a
							{...otherProps}
							style={{
								background: 'initial',
								color: theme.palette.secondary.main
							}}
							rel="noopener noreferrer"
							target="_blank"
						>
							{children}
						</a>
					),
					ul: otherProps => (
						<ul
							{...otherProps}
							style={{
								marginBlock: 8,
								marginInline: 0,
								paddingInlineStart: 30,
								listStyle: 'disc'
							}}
						/>
					),
					ol: otherProps => (
						<ol
							{...otherProps}
							style={{
								marginBlock: 8,
								marginInline: 0,
								paddingInlineStart: 30,
								listStyle: 'decimal'
							}}
						/>
					),
					li: otherProps => <li {...otherProps} style={{ margin: 4, listStyle: 'inherit' }} />
				}}
			/>
		</Typography>
	);
}
